














import {
    Prop, Component, Mixins,
} from 'vue-property-decorator';
import * as Rogues from '@rogues/index';

@Component({
    components: {
        ...Rogues,
    },
})

/**
 * @name RogueWrapper
 */
export default class RogueWrapper extends Mixins() {
    /**
     * The name of the rogue
     */
    @Prop() name!: string;

    /**
     * The type of the rogue
     */
    @Prop({ type: [String, Number] }) type!: [string, number];

    /**
     * Return name of rouge container
     *
     * @returns {string}
     */
    get rougeContainer(): string {
        return `y-${this.name}`;
    }
}
